<template>
  <div>
    <title-profile title="Perfil"></title-profile>
    <perfil-components></perfil-components>
    <delete-account></delete-account>
  </div>
</template>

<script>
import PerfilComponents from "./perfil_components/PerfilComponents";
import DeleteAccount from "../../tools/DeleteAccount";
import Title from "../geral/Title";

export default {
  name: "Profile",
  components: {
    "title-profile": Title,
    DeleteAccount,
    PerfilComponents
  },
  created() {

  }
};
</script>

<style scoped>
.bg_header {
  background-color: #1e88e5;
  padding: 9px 0 0 10px;
}
.font {
  color: white;
  border-bottom: 2px solid white;
  /*padding-bottom: 12px;*/
}
</style>
